import { Component, OnInit } from "@angular/core";
import { AuthenticationService } from "./services/authentication.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  constructor(private authentication: AuthenticationService) {}

  title = "refund-payment";
  sidebar: boolean = true;
  ngOnInit() {
    // if (this.authentication.isLoggedIn()) {
    //   this.sidebar = true;
    // }
  }
}
